import {
  PROJECT_ROADMAP_QUERY_KEYS,
  PROJECT_ROADMAP_UNASSIGNED_VALUE,
} from "./ProjectRoadmapPanel.jsx";

export function buildProjectTreeTitleSegments(
  search,
  unassignedLabel = "미지정",
) {
  const searchParams =
    search instanceof URLSearchParams ? search : new URLSearchParams(search);
  const definitions = [
    {
      key: "buildingName",
      queryKey: PROJECT_ROADMAP_QUERY_KEYS.buildingName,
    },
    {
      key: "floor",
      queryKey: PROJECT_ROADMAP_QUERY_KEYS.floor,
    },
    {
      key: "location",
      queryKey: PROJECT_ROADMAP_QUERY_KEYS.location,
    },
    {
      key: "facilityType",
      queryKey: PROJECT_ROADMAP_QUERY_KEYS.facilityType,
    },
    {
      key: "facilityName",
      queryKey: PROJECT_ROADMAP_QUERY_KEYS.facilityName,
    },
    { key: "partName", queryKey: PROJECT_ROADMAP_QUERY_KEYS.partName },
  ];

  return definitions
    .map(({ key, queryKey }) => {
      const value = searchParams.get(queryKey);
      if (!value) return null;

      return {
        key,
        queryKey,
        value,
        label:
          value === PROJECT_ROADMAP_UNASSIGNED_VALUE
            ? unassignedLabel
            : value,
      };
    })
    .filter(Boolean);
}

export function buildProjectTreeTitleLink(
  projectId,
  segments,
  segmentIndex,
) {
  const searchParams = new URLSearchParams();
  segments.slice(0, segmentIndex + 1).forEach((segment) => {
    searchParams.set(segment.queryKey, segment.value);
  });
  searchParams.set("page", "1");

  return `/project/${projectId}?${searchParams.toString()}`;
}
